export default function InkTurfIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#D9DDE5" />
      <path d="M4 10 C 14 4, 22 12, 30 8 C 34 20, 26 26, 32 36 C 24 44, 30 54, 20 60 L 4 60 Z" fill="#2F8BFF" />
      <circle cx="30" cy="20" r="5" fill="#2F8BFF" />
      <circle cx="12" cy="40" r="3" fill="#7FC0FF" />
      <path d="M60 6 C 50 10, 44 4, 38 12 C 42 22, 36 30, 42 40 C 36 50, 46 56, 40 60 L 60 60 Z" fill="#FF8A1F" />
      <circle cx="38" cy="48" r="4" fill="#FF8A1F" />
      <g transform="translate(28 34)">
        <rect x="8" y="3" width="10" height="4" fill="#3A3F52" />
        <circle r="10" fill="#8CC6FF" stroke="#164787" strokeWidth="2" />
        <path d="M-1.5 -9.4 A 9.5 9.5 0 0 0 -1.5 9.4 Z" fill="#1B5FC2" transform="rotate(0)" />
        <circle cx="-4" cy="0" r="3.5" fill="#F4F1E6" />
        <circle cx="5" cy="-4" r="2.4" fill="#FFFFFF" />
        <circle cx="5" cy="4" r="2.4" fill="#FFFFFF" />
        <circle cx="6" cy="-4" r="1.2" fill="#22263A" />
        <circle cx="6" cy="4" r="1.2" fill="#22263A" />
      </g>
      <circle cx="51" cy="35" r="3.5" fill="#2F8BFF" />
    </svg>
  );
}
